import { useState } from "react";
import { ChevronDown } from "lucide-react";
import EmptyCalculator from "./EmptyCalculator";
import CustomInput from "./CustomInput";

const Fibonacci = () => {
  // State for inputs
  const [trend, setTrend] = useState("Uptrend");
  const [high, setHigh] = useState("");
  const [low, setLow] = useState("");
  const [constant, setConstant] = useState("");

  // Results
  const [retracements, setRetracements] = useState([]);
  const [extensions, setExtensions] = useState([]);

  // Dropdown state
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const calculateFibonacci = () => {
    const highValue = parseFloat(high);
    const lowValue = parseFloat(low);
    const constantValue = parseFloat(constant);

    if (isNaN(highValue) || isNaN(lowValue) || isNaN(constantValue)) {
      setRetracements([]);
      setExtensions([]);
      return;
    }

    const fibRetracementLevels = [23.6, 38.2, 50.0, 61.8, 76.4];
    const fibExtensionLevels = [
      200.0, 185.4, 176.4, 161.8, 150.0, 138.2, 127.2,
    ];

    const newRetracements = [];
    const newExtensions = [];

    if (trend.toLowerCase() === "uptrend") {
      fibRetracementLevels.forEach((level) => {
        const value = highValue - (highValue - lowValue) * (level / 100);
        newRetracements.push({ level: `${level}%`, value: value.toFixed(2) });
      });

      fibExtensionLevels.forEach((level) => {
        const value = constantValue + (highValue - lowValue) * (level / 100);
        newExtensions.push({ level: `${level}%`, value: value.toFixed(2) });
      });
    } else {
      fibRetracementLevels.forEach((level) => {
        const value = lowValue + (highValue - lowValue) * (level / 100);
        newRetracements.push({ level: `${level}%`, value: value.toFixed(2) });
      });

      fibExtensionLevels.forEach((level) => {
        const value = constantValue - (highValue - lowValue) * (level / 100);
        newExtensions.push({ level: `${level}%`, value: value.toFixed(2) });
      });
    }

    setRetracements(newRetracements);
    setExtensions(newExtensions);
  };

  const hasResults = retracements.length > 0 && extensions.length > 0;

  return (
    <div className="flex gap-4 w-full">
      {/* Input Card */}
      <div className="bg-p400 rounded shadow-md w-1/2 p-4">
        <div className="mb-5">
          <label className="block text-xs font-medium text-n400 mb-2">
            Trend
          </label>
          <div className="relative">
            <div
              className="h-10 bg-n100 border border-n200 rounded px-2 flex justify-between items-center cursor-pointer"
              onClick={() => setDropdownOpen(!dropdownOpen)}>
              <span className="text-xs font-semibold text-p300">{trend}</span>
              <ChevronDown size={16} className="text-p300" />
            </div>

            {dropdownOpen && (
              <div className="absolute w-full mt-1 bg-p400 rounded shadow-lg z-10">
                {["Uptrend", "Downtrend"].map((option) => (
                  <div
                    key={option}
                    className="px-2 py-2 text-xs cursor-pointer hover:bg-n200 text-p300"
                    onClick={() => {
                      setTrend(option);
                      setDropdownOpen(false);
                    }}>
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <CustomInput
          label="High (a)"
          value={high}
          onChange={(e) => setHigh(e.target.value)}
          isNumberInput={true}
        />

        <CustomInput
          label="Low (b)"
          value={low}
          onChange={(e) => setLow(e.target.value)}
          isNumberInput={true}
        />

        <CustomInput
          label="Constant"
          value={constant}
          onChange={(e) => setConstant(e.target.value)}
          isNumberInput={true}
        />

        <button
          className="w-full py-2.5 bg-swipe-button text-xs font-medium text-p400 rounded my-3"
          onClick={calculateFibonacci}>
          Calculate
        </button>
      </div>

      {/* Results Card */}
      <div className="bg-p400 rounded shadow-md w-1/2">
        {!hasResults ? (
          <EmptyCalculator />
        ) : (
          <div>
            {/* Retracements */}
            <div className="p-3">
              <h3 className="text-md font-semibold mb-2 ml-3">Retracements:</h3>
              <table className="w-full">
                <tbody>
                  {retracements.map((row, index) => (
                    <tr key={index} className="border-t border-n200">
                      <td className="py-3 px-4 font-semibold text-sm text-p300">
                        {row.level}
                      </td>
                      <td className="py-3 px-4 text-right text-sm text-p300">
                        {row.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Extensions */}
            <div className="p-3 mt-5">
              <h3 className="text-md font-semibold mb-2 ml-3">Extensions:</h3>
              <table className="w-full">
                <tbody>
                  {extensions.map((row, index) => (
                    <tr key={index} className="border-t border-n200">
                      <td className="py-3 px-4 font-semibold text-sm text-p300">
                        {row.level}
                      </td>
                      <td className="py-3 px-4 text-right text-sm text-p300">
                        {row.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Fibonacci;
